
import { defineComponent, onMounted, ref, computed, toRefs, watch } from "vue";
import { useStore } from "vuex";
import { ICurrentUser } from "@/interfaces/iCurrentUser";
// import RecipientStatus from "@/views/email/views/components/recipientStatus.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { hasPermissionWrapper } from "@/core/services/permission.service";
import { CrudAction, VZ_PERMISSIONS } from "@/helpers/permissionMapper";
import { EmailAPI } from "@/services/api/Emails.service";
import { IEmail } from "@/interfaces/iEmails";
import { FormatMethods } from "@/helpers/data-format";
import { EmailBulkDelete, EmailFilters } from "./EmailOptions";
import { IBulkDelete } from "@/interfaces/iPageModel";
import { PAGE_ITEMS, usePagination } from "@/helpers/pagination";
import { TranslationService } from "@/core/services/TranslationService";
import { useToast } from "vue-toastification";
import VZModal from "@/components/content/VZModal.vue";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import VZFilter from "@/components/kt-datatable/components/VZFilter.vue";
import {
  FETCH_NOTIFICATION,
  NOTIFICATION_STORE,
  SET_NOTIFICATION_SUBSCRIPTION,
} from "@/store/notification/types";
import moment from "moment";
// import { boolean } from "yup/lib/locale";
interface IPagination {
  page: number;
  total: number;
  rowsPerPage: number;
  search?: string;
}
export default defineComponent({
  name: "emails-dashboard",
  components: {
    VZFilter,
    VZModal,
    // RecipientStatus,
  },
  // data() {
  //   return {
  //     total: 0,
  //     listQuery: {
  //       page: 1,
  //       limit: 20,
  //     },
  //   };
  // },
  emits: ["filter-change", "current-change"],
  props: {
    // selectedData: { type: Array, required: true },
    // enableItemsPerPageDropdown: { type: Boolean, default: true },
    defaultFilter: {},
    emailFilter: { type: Array as () => Array<Record<string, any>> }, //see table filter refrence
    viewName: { type: String, default: "" },
  },
  setup() {
    const store = useStore();
    const toast = useToast();
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const currentUser = computed(() => {
      return store.getters.currentUser as ICurrentUser;
    });
    const multipleDeleteSuccessMessage = t(
      "common.multipleDeleteSuccessMessage"
    );
    // const viewName = toRef(props, "viewName");
    // const refToElement = ref<HTMLInputElement>();
    const disableButton = ref<boolean>(true);

    const showDialog = ref<any>(false);
    const selectedForDeleteClass = ref<string>("primary");
    const allSelected = ref(false);
    const selectedForDelete = ref<number[]>([]);
    const { page, total, rowsPerPage } = usePagination();
    const PAGE_ITEM = ref<number[]>(PAGE_ITEMS);
    const deleteBtnLoading = ref<boolean>(false);
    const bulkDelete = ref<IBulkDelete>(EmailBulkDelete());
    const currentFilter = ref({});
    const options = ref(EmailFilters());
    const searchEmail = ref<string>("");
    const resendEmailById = ref<number>();
    const loading = ref(false);
    const emailsData = ref<IEmail[]>([]);
    const localPreference = ref({});
    const selectedData = ref<IEmail[]>([]);
    const pagination = ref<IPagination>({
      page: page.value,
      total: total.value,
      rowsPerPage: rowsPerPage.value,
    });
    const format = computed(() => {
      return FormatMethods;
    });
    const getEmailAddresses = (emailRecipientModel) => {
      return emailRecipientModel
        .map((subdata) => subdata.emailAddress)
        .join(", ");
    };
    onMounted(async () => {
      setCurrentPageBreadcrumbs(t("pages.email.emails"), ["Home", "Email"]);
      loading.value = true;
    });
    const filterChange = (filters) => {
      currentFilter.value = { ...filters };
      queryUpdate({
        ...currentFilter.value,
        page: 0,
        size: rowsPerPage.value,
        search: searchEmail.value,
        sort: "createdDate,desc",
      });
    };
    const searchChange = () => {
      queryUpdate({
        ...currentFilter.value,
        page: 0,
        size: rowsPerPage.value,
        search: searchEmail.value,
        sort: "createdDate,desc",
      });
    };
    const currentPageChange = (val) => {
      queryUpdate({
        ...localPreference.value,
        page: val - 1,
        sort: "createdDate,desc",
      });
    };
    const setItemsPerPage = () => {
      queryUpdate({
        ...localPreference.value,
        page: 0,
        size: rowsPerPage.value,
        sort: "createdDate,desc",
      });
    };
    const queryUpdate = async (params?: any) => {
      try {
        loading.value = true;
        localPreference.value = { ...params };
        const data = await EmailAPI.getInstance().getEmailsList({
          ...params,
          startDate: params?.startDate === null ? [] : params?.startDate,
        });
        emailsData.value = [...data.content];
        emailsData.value = emailsData.value.slice().sort((a, b) => {
          const dateA: Date = new Date(a.createdDate);
          const dateB: Date = new Date(b.createdDate);

          return dateB.getTime() - dateA.getTime();
        });
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } finally {
        selectedData.value = [];
        selectedData.value[0] = emailsData.value[0] ?? [];
        loading.value = false;
      }
    };
    selectedForDeleteClass.value = computed(() => {
      return disableButton.value == true ? "primary" : "danger";
    }).value;
    const onBulkDelete = async () => {
      showDialog.value = false;
      let deletedMsg = "Selected email(s) " + multipleDeleteSuccessMessage;
      await EmailAPI.getInstance()
        .bulkDeleteEntity(selectedForDelete.value)
        .then(() => {
          selectedForDelete.value = [];
          disableButton.value = true;
          selectedForDeleteClass.value = "primary";
          refreshList();
          toast.success(deletedMsg);
          allSelected.value = false;
        })
        .catch(() => {
          //
        });
    };
    const resendEmail = async () => {
      await EmailAPI.getInstance()
        .resendEmail(resendEmailById.value || 0)
        .then(() => {
          toast.success("message");
          refreshList();
        })
        .catch(() => {
          //
        })
        .finally(() => {
          loading.value = false;
        });
    };
    const refreshList = async () => {
      await queryUpdate({ ...localPreference.value });
      store.dispatch(`${NOTIFICATION_STORE}/${FETCH_NOTIFICATION}`);
    };
    watch(loading, (newValue) => {
      if (newValue) {
        store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      } else {
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }
    });
    const isUnreadForCurrentUser = (data: IEmail) => {
      if (!currentUser.value || !currentUser.value.email) return false;
      const recipient = data.emailRecipientModel?.find(
        (r) =>
          r.emailAddress.toLowerCase() === currentUser.value.email.toLowerCase()
      );
      return !!recipient && recipient.status === "PENDING";
    };
    return {
      currentUser,
      t,
      emailsData,
      loading,
      queryUpdate,
      format,
      selectedData, //to show the email details on the right side for the selected email.
      searchEmail,
      filterChange,
      options,
      currentFilter,
      bulkDelete,
      // checkAll,
      selectedForDelete,
      allSelected,
      deleteBtnLoading,
      onBulkDelete,
      pagination,
      currentPageChange,
      total,
      selectedForDeleteClass,
      page,
      rowsPerPage,
      searchChange,
      PAGE_ITEM,
      setItemsPerPage,
      resendEmail,
      resendEmailById,
      multipleDeleteSuccessMessage,
      hasPermissionWrapper,
      disableButton,
      refreshList,
      showDialog,
      VZ_PERMISSIONS,
      getEmailAddresses,
      // refToElement,
      isUnreadForCurrentUser,
    };
  },
  methods: {
    // async getEmailDetails(currentWebId, statusEmail) {
    //   for (let i = 0, len = this.emailsData.length; i < len; i++) {
    //     if (currentWebId == this.emailsData[i].webId) {
    //       this.emailsData[i].emailRecipientModel[0].status = "OPENED";
    //       this.selectedData[0] = this.emailsData[i];
    //     }
    //   }
    //   if (statusEmail == "PENDING") {
    //     await EmailAPI.getInstance().markEmailRead(currentWebId);
    //     store.dispatch(`${NOTIFICATION_STORE}/${FETCH_NOTIFICATION}`);
    //   }
    // },
    async getEmailDetails(currentWebId) {
      for (let i = 0, len = this.emailsData.length; i < len; i++) {
        if (currentWebId == this.emailsData[i].webId) {
          this.selectedData[0] = this.emailsData[i];
          const userEmail = this.currentUser.email;
          const recipient = this.emailsData[i].emailRecipientModel.find(
            (r) => r.emailAddress.toLowerCase() === userEmail.toLowerCase()
          );
          if (recipient && recipient.status === "PENDING") {
            recipient.status = "OPENED";
            await EmailAPI.getInstance().markEmailRead(currentWebId);
            store.dispatch(`${NOTIFICATION_STORE}/${FETCH_NOTIFICATION}`);
          }
        }
      }
    },
    searchForEmail() {
      var format = "@";
      if (this.searchEmail.match(format)) {
        this.queryUpdate({
          search: this.searchEmail,
          sort: "createdDate,desc",
          // fromEmail: this.searchEmail,
        });
      } else {
        this.queryUpdate({
          search: this.searchEmail,
          sort: "createdDate,desc",
          // fromName: this.searchEmail,
        });
      }
      // this.queryUpdate({
      //   // search: this.searchEmail,
      //   fromName: this.searchEmail,
      // });
    },
    selectAll() {
      if (this.selectedForDelete.length === this.emailsData.length) {
        this.selectedForDelete.length = 0;
        this.disableButton = true;
        this.allSelected = false;
      } else {
        this.selectedForDelete.length = 0;
        for (let i = 0, len = this.emailsData.length; i < len; i++) {
          this.selectedForDelete.push(this.emailsData[i].webId);
        }
        this.disableButton = false;
        this.allSelected = true;
      }
      this.selectedForDeleteClass =
        this.selectedForDelete.length > 0 ? "danger" : "primary";
    },
    checkSingle(n) {
      this.disableButton = false;
      this.selectedForDeleteClass = "danger";
      if (this.selectedForDelete.includes(n)) {
        for (var i = 0; i < this.selectedForDelete.length; i++) {
          if (this.selectedForDelete[i] === n) {
            this.selectedForDelete.splice(i, 1);
            if (this.selectedForDelete.length == 0) {
              this.disableButton = true;
              this.selectedForDeleteClass = "primary";
            }
          }
        }
      } else {
        this.selectedForDelete.push(n);
      }
    },
    applyDelete() {
      this.showDialog = false;
      this.selectedForDelete.push(this.selectedData[0].webId);
      this.onBulkDelete();
      this.selectedForDelete.pop();
    },
    printEmail() {
      var mywindow = window.open("");
      mywindow?.document.write(this.selectedData[0].body);
      mywindow?.document.close(); // necessary for IE >= 10
      mywindow?.focus(); // necessary for IE >= 10*/

      // mywindow?.print(); // this way the print window may load empty sometimes

      setTimeout(function () {
        mywindow?.print();
      }, 500);
      window.onfocus = function () {
        setTimeout(function () {
          mywindow?.close();
        }, 500);
      };
      return true;
    },
    getList() {
      // Fetch data
    },
    resend(n) {
      this.resendEmailById = n;
      this.resendEmail();
    },
  },
});
